import { render, staticRenderFns } from "./MemberInfo.vue?vue&type=template&id=1852d358&scoped=true"
import script from "./MemberInfo.vue?vue&type=script&lang=js"
export * from "./MemberInfo.vue?vue&type=script&lang=js"
import style0 from "./MemberInfo.vue?vue&type=style&index=0&id=1852d358&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1852d358",
  null
  
)

export default component.exports